import classnames from 'classnames';
import styles from './styles.module.scss';
import React, {ReactElement} from 'react';

const EmojiPeople = (): ReactElement => (
  <div className={classnames(styles.centerContent, styles.paddingTop, styles.paddingBottom)}>
    <div className={classnames(styles.circle, styles.color1)}>
      <span className={styles.emoji}>👧🏽</span>
    </div>
    <div className={classnames(styles.circle, styles.color2)}>
      <span className={styles.emoji}>👦🏿</span>
    </div>
    <div className={classnames(styles.circle, styles.color3)}>
      <span className={styles.emoji}>👧🏼</span>
    </div>
    <div className={classnames(styles.circle, styles.color4)}>
      <span className={styles.emoji}>👦🏻</span>
    </div>
  </div>
);

export default EmojiPeople;
